import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Title: {
    defaultMessage: 'Awesome products designed by independent artists',
    description: 'Default title of the explore page.'
  },
  Description: {
    defaultMessage:
      'Over 700,000 creatives worldwide making things like shirts, stickers, phone cases, and pillows weirdly meaningful. Find your thing or open your own shop.',
    description: 'Description of the explore page. (Visible in meta tags).'
  }
});

export default messages;
